import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Internal dependencies
 */
import { getNode, deepCopyLocksTreePath } from './utils';
var DEFAULT_STATE = {
  requests: [],
  tree: {
    locks: [],
    children: {}
  }
};
/**
 * Reducer returning locks.
 *
 * @param  {Object} state  Current state.
 * @param  {Object} action Dispatched action.
 *
 * @return {Object} Updated state.
 */

export function locks() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case 'ENQUEUE_LOCK_REQUEST':
      {
        var request = action.request;
        return _objectSpread(_objectSpread({}, state), {}, {
          requests: [request].concat(_toConsumableArray(state.requests))
        });
      }

    case 'GRANT_LOCK_REQUEST':
      {
        var lock = action.lock,
            _request = action.request;
        var store = _request.store,
            path = _request.path;
        var storePath = [store].concat(_toConsumableArray(path));
        var newTree = deepCopyLocksTreePath(state.tree, storePath);
        var node = getNode(newTree, storePath);
        node.locks = [].concat(_toConsumableArray(node.locks), [lock]);
        return _objectSpread(_objectSpread({}, state), {}, {
          requests: state.requests.filter(function (r) {
            return r !== _request;
          }),
          tree: newTree
        });
      }

    case 'RELEASE_LOCK':
      {
        var _lock = action.lock;

        var _storePath = [_lock.store].concat(_toConsumableArray(_lock.path));

        var _newTree = deepCopyLocksTreePath(state.tree, _storePath);

        var _node = getNode(_newTree, _storePath);

        _node.locks = _node.locks.filter(function (l) {
          return l !== _lock;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          tree: _newTree
        });
      }
  }

  return state;
}
export default locks;
//# sourceMappingURL=reducer.js.map